export default "/images/framework/EpicBarEng.eabcf09e.svg?eabcf09e";